import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Injectable } from '@angular/core';
import { apiEndpoints } from '../constants/api-endpoints';
import { HttpUtilityService } from './http.utility.service';
import { User } from '../interfaces/user';

@Injectable({ providedIn: 'root' })
export class UserService {
  constructor(private readonly httpUtilityService: HttpUtilityService) {}

  getUsers(): Observable<HttpResponse<User[]>> {
    return this.httpUtilityService.get<User[]>(
      apiEndpoints.manageAdminUserList
    );
  }

  addUser(user: any) {
    return this.httpUtilityService.post<any>(
      apiEndpoints.manageAdminUserList,
      user
    );
  }

  updateUser(id: number, user: any) {
    let path = `${apiEndpoints.manageAdminUserList}/${id}`;
    return this.httpUtilityService.put<any>(path, user);
  }

  deleteUser(id: number): Observable<HttpResponse<void>> {
    return this.httpUtilityService.delete<any>(
      apiEndpoints.manageAdminUserList,
      id
    );
  }
}
